<template>
  <!-- 固定在右下角的悬浮按钮容器 -->
  <div class="float-qrcode">
    <!-- 左侧悬浮出现的二维码外框（上下两部分 header + content） -->
    <div class="qrcode-show-container">
      <div class="qrcode-show-header">
        <span class="qrcode-show-header-text">添加微信咨询</span>
      </div>
      <div class="qrcode-show-content">
        <img
          class="qrcode-show-image"
          src="@/assets/image/kefuweixin.png"
          alt="客服微信二维码"
        />
      </div>
    </div>

    <!-- 右侧小按钮 -->
    <div class="qrcode-btn">
      <img class="qrcode-icon" src="@/assets/image/qr-icon.png" alt="关注微信" />
      <div class="qrcode-text">咨询客服</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatQrcode',
};
</script>

<style scoped>
.float-qrcode {
  position: fixed;
  right: 0;
  bottom: 62px;
  width: 51px;
  height: 51px;
  z-index: 1000;
}

.qrcode-btn {
  width: 51px;
  height: 51px;
  background: linear-gradient(180deg, #ce5efb 0%, #7149ff 100%);
  border-radius: 4px 0 0 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
  cursor: pointer;
  z-index: 1000;
}

.qrcode-icon {
  width: 18px;
  height: 18px;
  display: block;
}

.qrcode-text {
  margin-top: 4px;
  font-weight: 500;
  font-size: 10px;
  line-height: 1;
  color: #ffffff;
}

.qrcode-show-container {
  position: absolute;
  right: 60px; /* 在按钮左侧 */
  top: 50%;
  width: 86px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  transform: translateY(-50%) translateX(-10px);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  overflow: hidden; /* 防止内容溢出容器 */
}

.qrcode-show-header {
  height: 16px;
  flex: 0 0 16px;
  background: linear-gradient(88deg, #c95efb 0%, #7349ff 100%, rgba(201, 94, 251, 0) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px; /* 左右预留一点内边距，让横线不要贴边 */
}

.qrcode-show-header-text {
  position: relative;
  padding: 0 6px;
  font-weight: 500;
  font-size: 9px;
  color: #ffffff;
}

.qrcode-show-header-text::before,
.qrcode-show-header-text::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 6px;
  height: 1px;
  background: #ffffff;
  transform: translateY(-50%);
}

.qrcode-show-header-text::before {
  left: -8px;
}

.qrcode-show-header-text::after {
  right: -8px;
}

.qrcode-show-content {
  height: 84px;
  flex: 1 0 84px;
  background: #d389f6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-show-image {
  width: 80px;
  height: 80px;
  display: block;
}

.float-qrcode:hover .qrcode-show-container {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
  pointer-events: auto;
}
</style>
